import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import "./styles.css";
import { queryClient } from "@/app/query";
import { RouterProvider } from "@/app/router";
import { SessionProvider } from "@/app/session";
import { ToastProvider } from "@/components/Toast";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { App } from "@/app/App";
import { initTheme } from "@/app/theme";

initTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider>
          <SessionProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </SessionProvider>
        </RouterProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
